import React from 'react';

import { Typography } from 'antd';

import { CommunityAdminListType } from 'types/communities';

interface Props {
  item: CommunityAdminListType;
}

const CommunitiesTableCompetitors = ({ item }: Props) => {
  const competitorCommunitiesNames = (item?.competitors ?? []).map((competitor) => competitor.comunity_name);
  return (
    <Typography.Paragraph
      style={{ width: '100%', fontSize: 12, color: 'var(--text-secondary)', marginBottom: 0 }}
      ellipsis={{
        rows: 2,
        expandable: 'collapsible',
        symbol: (expanded: boolean) => (
          <div style={{ color: 'var(--dark-blue)', fontSize: 12 }}>{expanded ? 'Show Less' : 'Show More'}</div>
        ),
      }}
    >
      {competitorCommunitiesNames.join(', ')}
    </Typography.Paragraph>
  );
};

export default CommunitiesTableCompetitors;
